

import React, { memo, useCallback, useMemo } from 'react';
import cx from 'classnames';

import Switch from '../../Switch/components/Switch';

import '../styles/_switch-list.scss';









const SwitchList = (props) => {
  const {
    switchesProps,
    values,
    title,
    className,
    onChange
  } = props;

  const controlValues = useMemo(() => values || {}, [values]);

  const controlSwitchesProps = useMemo(() => switchesProps.map((switchProps) => {
    const labelProps = switchProps.labelProps || {};

    return {
      ...switchProps,
      labelProps: {
        ...labelProps,
        className: cx('switch-list__item', labelProps.className)
      }
    };
  }), [switchesProps]);

  const onChangeItem = useCallback((id, value) => {
    onChange({
      ...controlValues,
      [id]: value
    });
  }, [controlValues, onChange]);

  return (
    <div className={cx('switch-list', className)}>
      {title && <div className="switch-list__title">{title}</div>}

      {controlSwitchesProps.map(
        (controlSwitchProps) =>
        <Switch
          key={controlSwitchProps.id}
          {...controlSwitchProps}
          checked={!!controlValues[controlSwitchProps.id]}
          onChange={useCallback((
          value) =>
          onChangeItem(controlSwitchProps.id, value),
          [controlSwitchProps.id, onChangeItem]
          )} />


      )}
    </div>);

};

export default memo(SwitchList);